module.exports = __webpack_public_path__ + "static/homepage_stats-b1ecfe6d2772ec1d2731da5b9d28f835.jpg";